export interface FAQItem {
  question: string;
  answer: string;
}

export interface FAQCategory {
  title: string;
  faqs: FAQItem[];
}

// Categorías de preguntas frecuentes
export const faqCategories: FAQCategory[] = [
  {
    title: 'General',
    faqs: [
      {
        question: '¿Cuánto tiempo toma implementar una solución tecnológica?',
        answer:
          'El tiempo de implementación varía según la complejidad del proyecto. Para soluciones básicas, puede tomar entre 2-4 semanas, mientras que proyectos más complejos pueden requerir 2-6 meses. Durante nuestra consulta inicial, proporcionaremos un cronograma detallado específico para su proyecto.',
      },
      {
        question: '¿Ofrecen soporte técnico después de la implementación?',
        answer:
          'Sí, ofrecemos varios planes de soporte técnico post-implementación. Nuestro soporte básico incluye mantenimiento y resolución de problemas durante horario laboral, mientras que nuestros planes premium ofrecen soporte 24/7 y tiempos de respuesta garantizados. Todos nuestros proyectos incluyen un período de soporte inicial.',
      },
      {
        question: '¿Cómo garantizan la seguridad de los datos?',
        answer:
          'La seguridad de los datos es nuestra prioridad. Implementamos múltiples capas de protección, incluyendo encriptación de datos, autenticación de dos factores, y seguimos las mejores prácticas de la industria. Cumplimos con regulaciones de protección de datos y realizamos auditorías de seguridad periódicas para garantizar la integridad de su información.',
      },
      {
        question: '¿Pueden integrar sus soluciones con nuestros sistemas existentes?',
        answer:
          'Absolutamente. Nos especializamos en integraciones con sistemas existentes, ya sean ERP, CRM, o plataformas personalizadas. Nuestro equipo técnico evaluará sus sistemas actuales y desarrollará conectores específicos para garantizar una integración fluida, minimizando interrupciones en sus operaciones diarias.',
      },
    ],
  },
  {
    title: 'Empresa',
    faqs: [
      {
        question: '¿Cuánto tiempo lleva SOL IN PRIME JC en el mercado?',
        answer:
          'SOL IN PRIME JC cuenta con más de 5 años de experiencia en el mercado de soluciones tecnológicas empresariales. Durante este tiempo, hemos trabajado con empresas de diversos tamaños y sectores, lo que nos ha permitido desarrollar un profundo conocimiento de las necesidades específicas de cada industria.',
      },
      {
        question: '¿En qué se diferencia SOL IN PRIME JC de otras consultoras tecnológicas?',
        answer:
          'Nos distinguimos por nuestro enfoque personalizado y exclusivo. A diferencia de otras consultoras que ofrecen soluciones genéricas, nosotros desarrollamos estrategias a medida para cada cliente, considerando sus objetivos específicos, cultura organizacional y desafíos particulares. Además, nuestro equipo multidisciplinario combina experiencia técnica con conocimiento de negocios para ofrecer soluciones que realmente impulsen resultados tangibles.',
      },
      {
        question: '¿Trabajan con empresas de todos los tamaños?',
        answer:
          'Sí, trabajamos con empresas de todos los tamaños, desde startups hasta grandes corporaciones. Adaptamos nuestros servicios y soluciones según las necesidades y presupuesto de cada organización, manteniendo siempre el mismo nivel de calidad y compromiso. Para empresas más pequeñas, ofrecemos paquetes escalables que permiten implementar soluciones tecnológicas de forma gradual.',
      },
      {
        question: '¿Cuál es su metodología de trabajo?',
        answer:
          'Nuestra metodología se basa en un enfoque ágil y colaborativo que consta de cinco fases principales: 1) Diagnóstico y análisis de necesidades, 2) Diseño de la solución personalizada, 3) Desarrollo e implementación, 4) Pruebas y validación, y 5) Soporte y mejora continua. Durante todo el proceso, mantenemos una comunicación constante con nuestros clientes, realizando entregas incrementales que permiten ajustes y mejoras en tiempo real.',
      },
    ],
  },
  {
    title: 'Servicios',
    faqs: [
      {
        question: '¿Qué tipos de servicios de desarrollo web ofrecen?',
        answer:
          'Ofrecemos una amplia gama de servicios de desarrollo web, incluyendo: sitios web corporativos, tiendas online (e-commerce), aplicaciones web personalizadas, plataformas de gestión de contenidos, intranets corporativas, y optimización de sitios existentes. Todos nuestros desarrollos son responsivos, optimizados para SEO y diseñados con enfoque en la experiencia del usuario.',
      },
      {
        question: '¿Qué incluye su servicio de transformación empresarial?',
        answer:
          'Nuestro servicio de transformación empresarial es integral y abarca: diagnóstico digital de la organización, diseño de estrategia de transformación, implementación de nuevas tecnologías, automatización de procesos, capacitación del personal, gestión del cambio organizacional, y medición de resultados. El objetivo es modernizar completamente la operación de su empresa para aumentar la eficiencia y competitividad.',
      },
      {
        question: '¿Ofrecen servicios de consultoría en ciberseguridad?',
        answer:
          'Sí, nuestros servicios de consultoría en ciberseguridad incluyen: evaluación de vulnerabilidades, implementación de políticas de seguridad, protección de datos sensibles, configuración de sistemas de detección de intrusiones, planes de respuesta a incidentes, capacitación en seguridad para empleados, y auditorías periódicas. Trabajamos para proteger su información y sistemas contra amenazas cada vez más sofisticadas.',
      },
      {
        question: '¿Cómo funciona su servicio de implementación de ERP?',
        answer:
          'Nuestra implementación de ERP sigue un proceso estructurado que incluye: análisis de procesos actuales, selección de la solución más adecuada (ya sea personalizada o basada en plataformas como SAP, Microsoft Dynamics o soluciones open source), configuración según sus necesidades específicas, migración de datos, integración con sistemas existentes, capacitación de usuarios, y soporte post-implementación. Nos enfocamos en minimizar la interrupción de sus operaciones durante la transición.',
      },
    ],
  },
  {
    title: 'Funcionamiento',
    faqs: [
      {
        question: '¿Cómo inicia el proceso de trabajo con SOL IN PRIME JC?',
        answer:
          'El proceso comienza con una consulta inicial gratuita donde escuchamos sus necesidades y objetivos. Posteriormente, realizamos un diagnóstico detallado de su situación actual y presentamos una propuesta personalizada con alcance, cronograma y presupuesto. Una vez aprobada la propuesta, asignamos un equipo dedicado y comenzamos el desarrollo según la metodología acordada, manteniendo reuniones periódicas de seguimiento.',
      },
      {
        question: '¿Cómo se determina el costo de sus servicios?',
        answer:
          'El costo de nuestros servicios se determina en base a varios factores: complejidad del proyecto, alcance de la solución, plazos de entrega, recursos necesarios, y nivel de personalización requerido. Trabajamos con diferentes modelos de precios según el tipo de proyecto: precio fijo para proyectos bien definidos, tiempo y materiales para proyectos evolutivos, o modelos de suscripción para servicios continuos. En todos los casos, ofrecemos transparencia total en nuestra estructura de costos.',
      },
      {
        question: '¿Qué garantías ofrecen sobre sus servicios?',
        answer:
          'Ofrecemos garantías sólidas que incluyen: cumplimiento de plazos y presupuestos acordados, calidad técnica según estándares internacionales, período de garantía post-implementación (generalmente 3-6 meses), documentación completa de todas las soluciones, y compromiso de resolución de incidencias. Además, establecemos acuerdos de nivel de servicio (SLAs) claros para el soporte continuo.',
      },
      {
        question: '¿Cómo miden el éxito de sus implementaciones?',
        answer:
          'Medimos el éxito de nuestras implementaciones a través de KPIs específicos definidos al inicio del proyecto, que pueden incluir: retorno de inversión (ROI), reducción de costos operativos, aumento de productividad, mejora en satisfacción de clientes/empleados, reducción de errores, y tiempo de respuesta. Realizamos evaluaciones periódicas para asegurar que se estén alcanzando los objetivos establecidos y ajustamos la estrategia cuando es necesario.',
      },
    ],
  },
  {
    title: 'Tecnología',
    faqs: [
      {
        question: '¿Qué tecnologías utilizan para el desarrollo de soluciones?',
        answer:
          'Utilizamos un stack tecnológico moderno y diverso que incluye: lenguajes como JavaScript/TypeScript, Python, Java y PHP; frameworks como React, Angular, Vue.js, Django y Spring; bases de datos SQL y NoSQL; servicios cloud de AWS, Azure y Google Cloud; y herramientas de DevOps para integración y despliegue continuo. Seleccionamos la tecnología más adecuada para cada proyecto según sus requisitos específicos, siempre priorizando soluciones robustas, escalables y mantenibles.',
      },
      {
        question: '¿Sus soluciones son escalables para el crecimiento futuro?',
        answer:
          'Absolutamente. Diseñamos todas nuestras soluciones pensando en la escalabilidad desde el inicio. Utilizamos arquitecturas modulares, microservicios cuando es apropiado, y prácticas de desarrollo que facilitan la expansión futura. Además, documentamos exhaustivamente el código y los procesos para facilitar el mantenimiento y la evolución de los sistemas a medida que su negocio crece y sus necesidades cambian.',
      },
      {
        question: '¿Cómo gestionan la propiedad intelectual del software desarrollado?',
        answer:
          'La propiedad intelectual del software desarrollado a medida se transfiere completamente al cliente una vez finalizado el proyecto y realizados los pagos correspondientes. Esto incluye el código fuente, la documentación técnica y todos los elementos relacionados. En el caso de soluciones basadas en plataformas de terceros o componentes open source, le proporcionamos licencias adecuadas y transparencia total sobre los derechos de uso.',
      },
      {
        question: '¿Ofrecen capacitación para el uso de las soluciones implementadas?',
        answer:
          'Sí, la capacitación es una parte fundamental de nuestro proceso de implementación. Ofrecemos programas de formación personalizados para diferentes perfiles de usuarios: capacitación técnica para el personal de TI, formación para usuarios finales, y sesiones especializadas para administradores del sistema. Además, proporcionamos materiales de referencia, manuales de usuario y, en algunos casos, acceso a plataformas de e-learning para reforzar el conocimiento adquirido.',
      },
    ],
  },
];
